module.exports = __webpack_public_path__ + "static/media/nb1.bfc77e69.jpg";